import styled from "vue-styled-components";

export const Container = styled.div`
position: relative;
width: 100%;
padding: 20px;
`;
